var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 7.5a.5.5 0 0 0 1 0V6h8v1.5a.5.5 0 0 0 1 0V6h2a1 1 0 0 1 1 1v3H4V7a1 1 0 0 1 1-1h2zM3 11V7a2 2 0 0 1 2-2h2V3.5a.5.5 0 0 1 1 0V5h8V3.5a.5.5 0 0 1 1 0V5h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm17 0v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendarIcon;